// Mock data for VBGlobal website

export const companyInfo = {
  name: "VB Global",
  tagline: "Your Trusted Teammate",
  description: "Leading traders in eco-friendly paper chemicals, construction chemicals, SS wire mesh, high-pressure showers & nozzles, and dyes.",
  email: "enquiry.vbglobal@gmail.com",
  phone: "+91 78670 96977",
  address: "91 Adthiya Grand, Senamanaickenpalayam, Idigarrai, Coimbatore-641022",
  social: {
    linkedin: "https://www.linkedin.com/company/vbglobal/",
    facebook: "https://www.facebook.com/vbglobalcbe/"
  }
};

export const productCategories = [
  {
    id: "paper-chemicals",
    name: "Paper Chemicals",
    slug: "paper-chemicals",
    description: "Eco-friendly chemicals for superior paper quality and sustainable production",
    icon: "FileText",
    featured: true,
    image: "https://images.unsplash.com/photo-1586075010923-2dd4570fb338?w=800&q=80",
    products: [
      {
        name: "AKD (Alkyl Ketene Dimer)",
        description: "Advanced internal sizing agent for superior paper water resistance",
        benefits: ["Excellent sizing efficiency", "Improved water resistance", "Cost-effective application"]
      },
      {
        name: "Surface Sizing",
        description: "Surface treatment chemicals for enhanced paper properties",
        benefits: ["Improved surface strength", "Better printability", "Enhanced ink holdout"]
      },
      {
        name: "DSR (Dry Strength Resin)",
        description: "Increase paper strength in dry conditions",
        benefits: ["Enhanced tensile strength", "Better burst resistance", "Improved folding endurance"]
      },
      {
        name: "Burst Factor Improvement (Booster) Chemical",
        description: "Specialized additive to enhance burst strength of paper",
        benefits: ["Increased burst factor", "Better sheet integrity", "Reduced fiber consumption"]
      },
      {
        name: "Native Starch Cationization",
        description: "Cationic modification of native starch for better strength and reduce wet end chemical consumption",
        benefits: ["Increases cationicity from negative to +1000", "Reduction in starch consumption in wet end", "Enhanced bonding", "Cost reduction"]
      },
      {
        name: "Defoamer",
        description: "Control foam in paper production process",
        benefits: ["Efficient foam control", "No impact on paper quality", "Process optimization"]
      },
      {
        name: "AKD Booster",
        description: "Enhancer for AKD sizing performance",
        benefits: ["Improved sizing efficiency", "Faster curing", "Reduced chemical consumption"]
      },
      {
        name: "Ply Bond Improvement Chemical",
        description: "Strengthen bonding between paper plies",
        benefits: ["Superior ply adhesion", "Reduced delamination", "Enhanced board strength"]
      },
      {
        name: "Stiffness Improvement Chemical",
        description: "Increase paper stiffness and rigidity",
        benefits: ["Better stiffness ratio", "Improved bulk", "Enhanced convertibility"]
      },
      {
        name: "Ash Retention Chemical",
        description: "Optimize ash and filler retention in paper",
        benefits: ["Higher filler retention", "Reduced waste", "Cost savings"]
      },
      {
        name: "Retention & Drainage Aid",
        description: "Improve fiber and filler retention while enhancing drainage",
        benefits: ["Faster drainage", "Better retention", "Increased productivity"]
      },
      {
        name: "Flocculant",
        description: "Aggregate fine particles for improved retention",
        benefits: ["Enhanced flocculation", "Better water clarity", "Improved sheet formation"]
      },
      {
        name: "Coagulant",
        description: "Destabilize colloidal particles in paper production",
        benefits: ["Effective particle removal", "Improved water quality", "Process efficiency"]
      },
      {
        name: "ATC – Anionic Trash Control (AS ATC 1300)",
        description: "High charge-density cationic polymer dosed in the thick stock to neutralise anionic trash from recycled fibre and stabilise wet-end chemistry",
        benefits: ["Reduces and stabilises cationic demand", "Protects starch, AKD, dyes & retention aid efficiency", "Lower starch & AKD consumption", "Controls stickies and deposits", "Cleaner backwater, lower effluent load"],
        link: "/blog/anionic-trash-control-atc-wet-end"
      },
      {
        name: "Soda Recovery Boiler Antiscalant",
        description: "A typical blend of Phosphonates, Polyacrylates and neutralizing amines to prevent Silica, Calcium and Iron oxide scale formation in soda recovery boilers",
        benefits: ["Prevents silica scale formation", "Prevents calcium & iron oxide deposits", "Extends boiler life", "Improves heat transfer efficiency"]
      },
      {
        name: "Fluff Control",
        description: "Specialized chemical to control fluff generation caused by process parameter variations during paper production",
        benefits: ["Reduces fluff on dryers", "Improves printability", "Better surface quality"]
      }
    ]
  },
  {
    id: "construction-chemicals",
    name: "Construction Chemicals",
    slug: "construction-chemicals",
    description: "High-performance construction solutions for durable infrastructure",
    icon: "Building2",
    featured: true,
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80",
    products: [
      {
        name: "Concrete Admixture",
        description: "Advanced additives to enhance concrete performance",
        benefits: ["Improved workability", "Increased strength", "Reduced water content"]
      },
      {
        name: "Flyash Brick Admixture",
        description: "Specialized admixture for flyash brick production",
        benefits: ["Enhanced brick strength", "Better durability", "Eco-friendly solution"]
      },
      {
        name: "Paver Block Admixture",
        description: "High-performance additive for paver block manufacturing",
        benefits: ["Superior surface finish", "Increased density", "Weather resistance"]
      },
      {
        name: "Interlocking Bricks Admixture",
        description: "Optimize interlocking brick production quality",
        benefits: ["Better dimensional stability", "Enhanced strength", "Improved finish"]
      },
      {
        name: "Tile Adhesives & Grouts",
        description: "Professional-grade adhesives and grouting solutions",
        benefits: ["Strong bonding", "Water resistant", "Easy application"]
      },
      {
        name: "Waterproofing Chemicals",
        description: "Protect structures from water penetration",
        benefits: ["Long-lasting protection", "Prevents seepage", "Durable coating"]
      }
    ]
  },
  {
    id: "ss-wire-mesh",
    name: "SS Wire Mesh",
    slug: "ss-wire-mesh",
    description: "Premium stainless steel wire mesh for industrial applications",
    dealer: "Maheen Wire Mesh Industries, Jaipur",
    icon: "Grid3x3",
    featured: true,
    image: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800&q=80",
    products: [
      {
        name: "Open Ended Wire Mesh (5 to 200 Mesh)",
        description: "Versatile stainless steel wire mesh with open-ended design for various filtration and industrial applications",
        benefits: ["Wide mesh range (5-200)", "Corrosion resistant", "High tensile strength", "Long service life"]
      },
      {
        name: "Diagonal Seam Wire Mesh (5 to 60 Mesh)",
        description: "Premium diagonal seam stainless steel mesh for demanding industrial requirements",
        benefits: ["Mesh range 5-60", "Strong seam construction", "Uniform aperture", "Easy to install"]
      }
    ]
  },
  {
    id: "high-pressure-showers",
    name: "High Pressure Showers & Nozzles",
    slug: "high-pressure-showers",
    description: "Industrial cleaning systems for paper and manufacturing industries",
    dealer: "Audley Industries, Calcutta",
    icon: "Droplets",
    featured: true,
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80",
    products: [
      {
        name: "Stationary Showers",
        description: "Fixed position high-pressure cleaning showers for continuous operation",
        benefits: ["Consistent cleaning performance", "Low maintenance", "Reliable operation"]
      },
      {
        name: "Starch Spray Showers",
        description: "Specialized showers for uniform starch application",
        benefits: ["Even starch distribution", "Adjustable spray pattern", "Reduced starch consumption"]
      },
      {
        name: "Oscillation Showers",
        description: "Dynamic oscillating showers for enhanced cleaning coverage",
        benefits: ["Wide coverage area", "Uniform cleaning", "Energy efficient"]
      },
      {
        name: "Electromechanical Variable Speed Oscillating Showers",
        description: "Advanced oscillating showers with adjustable speed control",
        benefits: ["Variable speed control", "Precise cleaning", "Programmable operation"]
      },
      {
        name: "Tube IN Tube Showers",
        description: "Innovative dual-tube design for efficient cleaning",
        benefits: ["Enhanced cleaning efficiency", "Reduced water consumption", "Compact design"]
      },
      {
        name: "Brush Showers",
        description: "Combined brush and shower system for deep cleaning",
        benefits: ["Mechanical + water cleaning", "Removes stubborn deposits", "Extended equipment life"]
      },
      {
        name: "High Pressure Nozzles",
        description: "Robust nozzles for high-pressure cleaning applications",
        benefits: ["Powerful cleaning action", "Durable construction", "Wide spray angles"]
      },
      {
        name: "Low Pressure Nozzles",
        description: "Gentle spray nozzles for sensitive applications",
        benefits: ["Controlled spray pattern", "Water efficient", "Gentle on surfaces"]
      },
      {
        name: "Edge Cutting / Trim Squirt Nozzles",
        description: "Precision nozzles for edge trimming operations",
        benefits: ["Accurate edge cutting", "Clean trim", "Reduced waste"]
      },
      {
        name: "Starch Spray Nozzles",
        description: "Specialized nozzles for starch application",
        benefits: ["Uniform starch coating", "Adjustable flow", "Easy maintenance"]
      },
      {
        name: "Duplex Filters",
        description: "Dual filtration system for continuous operation",
        benefits: ["Continuous filtration", "Easy switchover", "Reduced downtime", "Extended filter life"]
      }
    ]
  },
  {
    id: "dyes",
    name: "Dyes",
    slug: "dyes",
    description: "High-performance dyes and optical brighteners for consistent, vibrant coloring of paper and board",
    icon: "Palette",
    featured: true,
    image: "https://static.prod-images.emergentagent.com/jobs/82ca6c7d-3d48-485a-b28b-36e32b448663/images/67bddb93732374c05ac8edf9396caa29046b98e168ef72aad698189f25c001ce.jpeg",
    products: [
      {
        name: "Direct Dyes",
        description: "Anionic, water-soluble dyes with strong natural affinity for cellulose fibres, ideal for wet-end shading and bulk coloring of paper and board",
        benefits: ["High affinity to cellulose fibres", "Good light and bleed fastness", "Economical for bulk shading", "Wide range of shades", "Suitable for wet-end and surface application"]
      },
      {
        name: "Basic Dyes",
        description: "Cationic dyes delivering brilliant, deep shades on unbleached, kraft and recycled pulps with lignin-rich fibres",
        benefits: ["Brilliant, vivid shades", "Excellent affinity to unbleached & recycled pulp", "High tinctorial strength - low dosage", "Cost-effective coloring for kraft and tissue"]
      },
      {
        name: "Acid Dyes",
        description: "Anionic dyes offering bright shades and excellent leveling, best suited for tissue, specialty papers and size-press coloring with fixing agents",
        benefits: ["Bright, brilliant shades", "Excellent leveling and uniform dyeing", "Ideal for tissue and specialty papers", "Good solubility and easy dosing"]
      },
      {
        name: "OBA (Optical Brightening Agents)",
        description: "Stilbene-based fluorescent whitening agents that absorb UV light and re-emit blue light, boosting whiteness and brightness of paper",
        benefits: ["Significant boost in CIE whiteness", "Reduces bleaching chemical consumption", "Di, Tetra and Hexa sulphonated grades", "Suitable for wet-end, size press and coating"]
      }
    ]
  }
];

export const solutions = [
  {
    id: 1,
    problem: "Poor Strength and Formation",
    solution: "Our specialized tailored made chemicals improve wet end chemistry i.e improve fiber bonding and formation",
    products: ["Retention Aids", "Wet Strength Resins", "DSR"],
    benefits: ["Enhanced paper quality", "Reduced production waste", "Better runnability"]
  },
  {
    id: 2,
    problem: "High Production Costs",
    solution: "Eco-friendly chemicals that optimize resource usage and reduce chemical dosage",
    products: ["Defoamers", "Sizing Agents", "AKD Booster"],
    benefits: ["Cost reduction", "Improved efficiency", "Sustainable practices"]
  },
  {
    id: 3,
    problem: "Water Absorption Problems",
    solution: "Advanced sizing agents that control water absorption and improve printability",
    products: ["AKD", "Surface Sizing", "AKD Booster"],
    benefits: ["Better print quality", "Consistent performance", "Product versatility"]
  },
  {
    id: 4,
    problem: "Burst Factor Improvement",
    solution: "Specialized burst factor booster chemicals to enhance paper and board burst strength",
    products: ["Burst Factor Improvement Booster", "DSR"],
    benefits: ["Increased burst factor", "Stronger sheets", "Reduced fiber consumption"]
  },
  {
    id: 5,
    problem: "Stiffness Improvement in Board",
    solution: "Targeted stiffness improvement chemicals for board and packaging grades",
    products: ["Stiffness Improvement Chemical", "Native Starch Cationization"],
    benefits: ["Higher stiffness ratio", "Better board performance", "Improved convertibility"]
  },
  {
    id: 6,
    problem: "Plybond Issues",
    solution: "Ply bond improvement chemicals that strengthen bonding between paper plies",
    products: ["Ply Bond Improvement Chemical"],
    benefits: ["Superior ply adhesion", "Reduced delamination", "Enhanced board strength"]
  },
  {
    id: 7,
    problem: "Retention and Water Drainage Improvement",
    solution: "Advanced retention and drainage aid systems for improved efficiency and runnability",
    products: ["Retention & Drainage Aid", "Flocculant", "Coagulant"],
    benefits: ["Faster drainage", "Higher retention", "Increased machine speed"]
  },
  {
    id: 8,
    problem: "Smoothness Improvement in Kraft",
    solution: "Surface treatment chemicals to enhance smoothness and finish of kraft paper",
    products: ["Surface Sizing", "Native Starch Cationization"],
    benefits: ["Improved smoothness", "Better printability", "Enhanced surface quality"]
  },
  {
    id: 9,
    problem: "Starch Cationization for Better Paper Properties",
    solution: "Native starch cationization solutions for improved retention, bonding, and cost savings",
    products: ["Native Starch Cationization"],
    benefits: ["Better retention", "Improved bonding", "Cost-effective alternative"]
  },
  {
    id: 10,
    problem: "Environmental Compliance",
    solution: "Green chemistry solutions that meet environmental standards without compromising quality",
    products: ["All Paper Chemicals"],
    benefits: ["Eco-friendly", "Regulatory compliance", "Sustainable production"]
  },
  {
    id: 11,
    problem: "Concrete Admixture Solutions",
    solution: "High-performance concrete admixtures to enhance workability, strength and durability of concrete",
    products: ["Concrete Admixture"],
    benefits: ["Improved workability", "Higher strength", "Reduced water content"]
  },
  {
    id: 12,
    problem: "Flyash Bricks Admixture",
    solution: "Specialized admixtures for flyash brick manufacturing for better strength and finish",
    products: ["Flyash Brick Admixture"],
    benefits: ["Enhanced brick strength", "Better durability", "Eco-friendly solution"]
  },
  {
    id: 13,
    problem: "Tiles Adhesives & Grouts",
    solution: "Professional-grade tile adhesives and grouts for strong, water-resistant bonding",
    products: ["Tile Adhesives & Grouts"],
    benefits: ["Strong adhesion", "Water resistant", "Easy application"]
  },
  {
    id: 14,
    problem: "Interlocking Bricks Solutions",
    solution: "Specialized admixtures to optimize interlocking brick production quality and dimensional stability",
    products: ["Interlocking Bricks Admixture"],
    benefits: ["Dimensional stability", "Enhanced strength", "Improved finish"]
  },
  {
    id: 15,
    problem: "Paver Block Admixture",
    solution: "High-performance additives for paver block manufacturing with superior finish and weather resistance",
    products: ["Paver Block Admixture"],
    benefits: ["Superior surface finish", "Increased density", "Weather resistant"]
  },
  {
    id: 16,
    problem: "SS Wire Mesh - Open Ended & Diagonal Seam",
    solution: "Premium stainless steel wire mesh in open ended (5-200 mesh) and diagonal seam (5-60 mesh) variants for industrial applications",
    products: ["Open Ended Wire Mesh", "Diagonal Seam Wire Mesh"],
    benefits: ["Wide mesh range", "Corrosion resistant", "Long service life"]
  },
  {
    id: 17,
    problem: "High Pressure Oscillating & Stationary Showers",
    solution: "Robust high-pressure showers for continuous and oscillating cleaning of paper machine equipment",
    products: ["Stationary Showers", "Oscillation Showers"],
    benefits: ["Consistent cleaning", "Reduced downtime", "Energy efficient"]
  },
  {
    id: 18,
    problem: "Starch Spray Showers",
    solution: "Specialized showers for uniform starch application on paper machines",
    products: ["Starch Spray Showers"],
    benefits: ["Even starch distribution", "Adjustable spray pattern", "Reduced starch consumption"]
  },
  {
    id: 19,
    problem: "Electromechanical Variable Speed Oscillating Showers",
    solution: "Advanced oscillating showers with programmable speed control for precise cleaning operations",
    products: ["Electromechanical Variable Speed Oscillating Showers"],
    benefits: ["Variable speed control", "Precise cleaning", "Programmable operation"]
  },
  {
    id: 20,
    problem: "Brush Showers",
    solution: "Combined brush and shower systems for deep cleaning of stubborn deposits on equipment",
    products: ["Brush Showers"],
    benefits: ["Mechanical + water cleaning", "Removes stubborn deposits", "Extended equipment life"]
  },
  {
    id: 21,
    problem: "Industrial Nozzles - High & Low Pressure",
    solution: "Complete range of nozzles for industrial cleaning - high pressure, low pressure, edge cutting/trim squirt and starch spray nozzles",
    products: ["High Pressure Nozzles", "Low Pressure Nozzles", "Edge Cutting/Trim Squirt Nozzles", "Starch Spray Nozzles"],
    benefits: ["Powerful & precise cleaning", "Durable construction", "Wide application range"]
  }
];

export const aboutUs = {
  mission: "To provide innovative, eco-friendly solutions that empower industries to achieve excellence while protecting our environment.",
  vision: "To be the most trusted global partner in sustainable industrial solutions.",
  values: [
    {
      title: "Sustainability",
      description: "Committed to eco-friendly products and green manufacturing practices",
      icon: "Leaf"
    },
    {
      title: "Quality",
      description: "Delivering premium products that meet the highest industry standards",
      icon: "Award"
    },
    {
      title: "Innovation",
      description: "Continuously developing solutions that address evolving industry needs",
      icon: "Lightbulb"
    },
    {
      title: "Partnership",
      description: "Building long-term relationships as your trusted teammate",
      icon: "Handshake"
    }
  ],
  certifications: [
    "ISO 9001:2015 Certified",
    "Eco-Friendly Certified",
    "Environmental Management System",
    "Quality Assurance Standards"
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Valued Client",
    company: "Paper Industry",
    position: "Production Team",
    text: "VB Global product quality is consistent across all supplies and their support team is always helpful and on time when needed.",
    rating: 5
  }
];
